import Requester from "common/network/http/Request";
import { showResponseMessage } from "common";
import { call, put, takeLatest } from "redux-saga/effects";
import { summitFormTypes } from "schema-form/action-creators";

function* handleSummitForm(action) {
  const { values, options, url } = action;
  const attachedNodes = options && options.attachedNodes ? options.attachedNodes : {};
  const nodeAction = options && options.nodeAction ? options.nodeAction : {};
  const method = action.method || "post";
  const response = yield call(
    Requester[method].bind(Requester),
    url,
    values,
    {
      headers: {
        attachedNodes: JSON.stringify(attachedNodes),
        nodeAction,
      },
    },
  );

  if (!options.disableResponseMessage) {
    showResponseMessage(response);
  }

  if (response && (response.status === undefined || response.status < 400 || (options && response[options.checkSuccessOnField]))) {
    if (options && options.dispatchAfterSuccess) {
      if (options.dispatchFullResponse) {
        yield put(options.dispatchAfterSuccess(response));
      } else {
        yield put(options.dispatchAfterSuccess(response.data || response));
      }
    }
    if (options && options.onSuccess) {
      if (options.dispatchFullResponse) {
        options.onSuccess(response, values);
      } else {
        options.onSuccess(response.data || response, values);
      }
    }
    return;
  }
  if (options && options.onFail) {
    options.onFail(response, values);
  }
}

export default function* () {
  return [
    yield takeLatest(summitFormTypes.HANDLE_SUMMIT_FORM, handleSummitForm),
  ];
}
